import React, { useCallback, useEffect, useState } from 'react';

import Axios from 'axios';
import cookieCutter from 'cookie-cutter';
import Head from 'next/head';

import getMetaTagData from '../../src/common/services/getMetaTagData';

import Slider from '../../src/component/pc/carousel/Slider';
import Loading from '../../src/component/pc/common/Loading';
import Title from '../../src/component/pc/common/Title';
import Info from '../../src/component/pc/live/InfoWrapper';
import Player from '../../src/component/pc/live/PlayerWrapper';
import Side from '../../src/component/pc/live/SideWrapper';

import { deduplArray, toTimeStamp } from '../../src/common/utils/convertUtil';
import {
  getLiveChannelType,
  getLivePlanArray,
  toPlanUrl,
} from '../../src/common/utils/liveUtil';

import * as MODE from '../../src/common/constants/live/mode';

const LiveViewPage = (props, metaTagData) => {
  const [onair, setOnair] = useState(props.data.onair);

  useEffect(() => {
    setOnair(onair);

    if (process.env.NODE_ENV === 'production') {
      let tagId, ga4TagId;
      switch (onair.info.channelid) {
        case 'S02': // sbs sports
          tagId = 'UA-146376328-1';
          break;
        case 'S03': // sbs plus
          tagId = 'UA-146760740-2';
          ga4TagId = 'G-97W8RH442C';
          break;
        case 'S04': // sbs fune
          tagId = 'UA-146760740-3';
          ga4TagId = 'G-WQWE5WDT9F';
          break;
        // case 'S05': // sbs golf
        //   tagId = 'UA-100348188-1';
        //   break;
        case 'S06': // sbs biz
          tagId = 'UA-135761934-1';
          break;
        case 'S09': // sbs m
          tagId = 'UA-146888827-4';
          ga4TagId = 'G-0DM6QEB0KJ';
          break;
        case 'S10': // kizmom, S20 kpop,
          tagId = 'UA-146888827-5';
          ga4TagId = 'G-YHQ768DD4V';
          break;
        case 'S11': // fil
          ga4TagId = 'G-VL8DPHLZZJ';
          break;
        default:
          tagId = null;
          ga4TagId = null;
          break;
      }

      if (ga4TagId || tagId) {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', ga4TagId ? ga4TagId : tagId, {
          page_location: window.location.href,
          page_path: window.location.pathname,
          page_title: window.document.title,
        });
      }
    }
  }, [onair]);

  return (
    <>
      <div
        className="live_popup contents"
        id="container"
        style={{ padding: 0 }}
      >
        <link
          rel="stylesheet"
          type="text/css"
          href={process.env.URL_LIVE_CSS_PLAYER + '?v=20221122102953'}
          media="all"
        />
        <script src={process.env.URL_LIVE_JS_VENDOR} type="text/javascript" />
        <script
          src={
            onair && onair.info.type === 'Radio'
              ? process.env.URL_LIVE_JS_RADIO_PLAYER
              : process.env.URL_LIVE_JS_PLAYER
          }
          type="text/javascript"
        />
        <script
          src={process.env.NEXT_PUBLIC_URL_LIVE_JS_PLAYER_NEW}
          type="text/javascript"
        />
        <script
          src={process.env.URL_LIVE_JS_PLAYER_UI}
          type="text/javascript"
        />
        <script src={process.env.URL_LIVE_JS_IMA3} type="text/javascript" />
        <script src={process.env.URL_LIVE_JS_JQUERY} type="text/javascript" />
        <script
          src={process.env.URL_LIVE_JS_SOCKET_IO}
          type="text/javascript"
        />
        <script
          src={process.env.URL_LIVE_JS_SOCKET_IO_V2_0_3}
          type="text/javascript"
        />
        <script src={process.env.URL_LIVE_JS_SENDBIRD} type="text/javascript" />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=UA-146376328-1"
          type="text/javascript"
        />
        <Head>
          <link
            key="css_pc_url"
            rel="stylesheet"
            href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
          />
          <meta
            key="viewport"
            name="viewport"
            content="width=device-width, initial-scale=1"
          />
          <script
            key="gnb_js_url"
            type="text/javascript"
            src={process.env.NEXT_PUBLIC_GNB_JS_URL}
          />

          <meta
            name="description"
            content={props.metaTagData.shareDescription}
          />
          <meta name="keywords" content={props.metaTagData.keywords} />
          <meta name="twitter:card" content="summary" />
          <noscript>Your browser does not support JavaScript!</noscript>
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="ko_KR" />
          <meta property="og:site_name" content="SBS" />
          <meta
            property="og:title"
            content={props.metaTagData.shareTitle || ''}
          />
          <meta
            property="og:description"
            content={props.metaTagData.shareDescription || ''}
          />
          <meta
            property="og:image"
            content={props.metaTagData.shareImageUrl || ''}
          />
          <meta
            property="og:url"
            content={props.metaTagData.currentUrl || ''}
          />
          <meta name="nate:site_name" content="SBS" />
          <meta
            name="nate:title"
            content={props.metaTagData.shareTitle || ''}
          />
          <meta
            name="nate:description"
            content={props.metaTagData.shareDescription || ''}
          />
          <meta
            name="nate:image"
            content={props.metaTagData.shareImageUrl || ''}
          />
          <meta name="nate:url" content={props.metaTagData.currentUrl || ''} />
          <title>{props.metaTagData.shareTitle}</title>
        </Head>
        <div id="container">
          <div className="contents_area_player">
            <div className="live_player_w">
              <div className="live_player_inner">
                {onair.info && <Player data={onair.info} />}
                {!onair.info && <Loading />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  // 가상 또는 라디오채널은 채널이름 명확하지 않아 채널아이디로 하는게 좋아보임
  const channelID = ctx.query.channel;
  const channelType = getLiveChannelType(channelID);

  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const metaTagData = getMetaTagData(ctx.asPath, 'live', channelID);

  try {
    const apiChannelPath =
      channelType !== '24tv' ? 'channel' : 'binge-watch/channel';
    const infoApiUrl = `${process.env.NEXT_PUBLIC_API_LIVE_INFO}/${apiChannelPath}/${channelID}?v_type=2&platform=pcweb&protocol=hls&ssl=N&rscuse=&jwt-token=&sbsmain=`;

    const res = await Axios.get(infoApiUrl);
    const data = res.data;

    return {
      props: {
        data: data || null,
        metaTagData,
      },
    };
  } catch (error) {
    console.error(error);
  }
}

export default LiveViewPage;
